module.exports = __webpack_public_path__ + "img/analyzing-photo-mobile-fr.0ce8a0b8.jpg";